var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStory = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M9.71 8.326c0-2.53-3.83-1.809-3.83-2.875 0-.407.34-.67.94-.67.68 0 1.4.233 1.94.74l.79-1.076c-.66-.62-1.54-.945-2.6-.945-1.57 0-2.53.935-2.53 2.062 0 2.55 3.84 1.728 3.84 2.906 0 .396-.37.752-1.16.752a2.9 2.9 0 0 1-2.12-.925L4.2 9.423c.63.64 1.55 1.077 2.84 1.077 1.79 0 2.67-.935 2.67-2.174"
}))));
export default SvgStory;